import styled from 'styled-components';

export const ModalStyle = styled.div`
  position: fixed;  
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  padding: 20px;
  width: 800px;
  height: 500px;
  background: #fff;
  border-radius: 5px;
  overflow-x: auto;
  z-index: 2;

  h4, p {
    font-family: 'Poppins', sans-serif!important;
  }

  h4 {
    font-size: 19px;
    text-align: center;
    margin-bottom: 20px;
  }

  p {
    text-align: left!important;
    margin-bottom: 30px!important;
  }
`;
